export default "__VITE_ASSET__CXOpHili__"